export const PasswordCodes = {
  OK: 0,
  NOT_MATCHING: 1,
  AUTH_FAILED: 401,
  INTERNAL_ERROR: 500,
}
